
const messages ={
        message:{
            about : 'Hakkımızda',
            home : 'Anasayfa',
            required :'Bu alan zorunludur',
            haveAccount :'Hesabım var',
            login:'Giriş Yap',
            logout:'Çıkış Yap',
            mailAdress:'Mail Adress',
            password :'Şifre',
            passwordNumberReqiured : 'Şifreniz sadece rakamlardan oluşmalıdır.',
            passwordMinMust : 'Şifreniz en az ',
            passwordMaxMust : 'Şifreniz en fazla ',        
            passwordCharacters : 'karakterden oluşmalıdır ',
            passwordSameAs:'Şifreler uyuşmuyor',
            register :'Kayıt Ol',
            signIn :'Giriş Yap ',
            signUp:'Üye Ol',
            validEmail :'Lütfen geçerli bir mail adresi giriniz',
        }
    }

export default messages ;